import React from "react";

import { IManualPaymentRecord } from "../../../../libs";
import * as Styled from "./UpdateManualPaymentModal.styled";

const formatMoney = (amount: number, currency: string) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount / 100);

export const ManualPaymentHistory: React.FC<{
  payments: IManualPaymentRecord[];
}> = ({ payments }) => (
  <Styled.Section>
    <Styled.SectionTitle>Manual payment history</Styled.SectionTitle>
    {payments.length ? (
      <Styled.HistoryTableWrapper>
        <Styled.HistoryTable>
          <thead>
            <tr>
              <th>Paid</th>
              <th>Plan</th>
              <th>Method</th>
              <th>Coverage</th>
              <th>Invoice</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.paymentId}>
                <td>
                  {formatMoney(payment.amountPaid, payment.currency)}
                  <small>{new Date(payment.paidAt).toLocaleDateString()}</small>
                </td>
                <td>{payment.packageName}</td>
                <td>
                  {payment.paymentMethod.replaceAll("_", " ")}
                  <small>{payment.paymentReference}</small>
                </td>
                <td>
                  {new Date(payment.coverageStart).toLocaleDateString()} –{" "}
                  {new Date(payment.coverageEnd).toLocaleDateString()}
                </td>
                <td>
                  {payment.hostedInvoiceUrl ? (
                    <a href={payment.hostedInvoiceUrl} target="_blank" rel="noreferrer">
                      {payment.stripeInvoiceNumber || "View"}
                    </a>
                  ) : (
                    payment.stripeInvoiceNumber || "Created"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Styled.HistoryTable>
      </Styled.HistoryTableWrapper>
    ) : (
      <Styled.EmptyHistory>No manual payments recorded yet.</Styled.EmptyHistory>
    )}
  </Styled.Section>
);
